export enum SkuId {
    HGApiIntegration2026 = 'INT-HG-26',
    CICompassStandard = 'CI-STD-26',
    CICompassPremium = 'CI-PRM-26',
}
